export default function Header() {
  return (
    <header className="Header">
        <h1 className="Header-Title">Game Reviews</h1>
        <p className="Header-Subtitle">A place to find real world feedback on games.</p>
    </header>
  )
}
